import React, { useState, useEffect } from 'react';
import { dashboardService } from '../services/dashboardService';
import Loading from '../components/common/Loading';
import StatsCard from '../components/dashboard/StatsCard';
import RecentOrders from '../components/dashboard/RecentOrders';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDashboardStats();
  }, []);

  const loadDashboardStats = async () => {
    try {
      setLoading(true);
      setError(''); // Clear any previous errors
      const data = await dashboardService.getDashboardStats();
      setStats(data);
    } catch (err) {
      // Provide user-friendly error messages
      let errorMessage = 'Failed to load dashboard statistics';
      
      if (err.message) {
        errorMessage = err.message;
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.isHtmlResponse) {
        errorMessage = 'Cannot connect to backend API. Please ensure the server is running.';
      }
      
      console.error('Dashboard error:', err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading message="Loading dashboard..." />;
  }

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  if (!stats) {
    return <div className="error-container">No data available</div>;
  }

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Dashboard</h1>

      <div className="stats-grid">
        <StatsCard
          title="Total Products"
          value={stats.products?.total || 0}
          subtitle={`${stats.products?.active || 0} active`}
          color="#4285f4"
        />
        <StatsCard
          title="Out of Stock"
          value={stats.products?.outOfStock || 0}
          subtitle="products"
          color="#ea4335"
        />
        <StatsCard
          title="Total Orders"
          value={stats.orders?.total || 0}
          subtitle={`${stats.orders?.pending || 0} pending`}
          color="#34a853"
        />
        <StatsCard
          title="Completed Orders"
          value={stats.orders?.completed || 0}
          subtitle="delivered"
          color="#137333"
        />
        <StatsCard
          title="Total Users"
          value={stats.users?.total || 0}
          subtitle="customers"
          color="#9334e6"
        />
        <StatsCard
          title="Total Revenue"
          value={`Rs. ${parseFloat(stats.revenue?.total || 0).toLocaleString()}`}
          subtitle="from delivered orders"
          color="#fbbc04"
        />
      </div>

      <div className="recent-orders-section">
        <h2 className="section-title">Recent Orders</h2>
        <RecentOrders orders={stats.recentOrders || []} />
      </div>
    </div>
  );
};

export default Dashboard;
